<template>
    <ContentOrLoading :style="loading && !svgRendered ? 'padding: 100px;' : ''">
        <div class="row" v-if="!loading && svgRendered">
            <div class="col-12 p-3">
                <LeafletComponent 
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
                <div class="mt-3">
                    <LeyendaColorPlano/>
                </div>
                <div>
                    <Button class="m-3" @click.prevent="selectAllButacas">{{ plazas ? 'Seleccionar/Limpiar todas' : 'Seleccionar todas'}}</Button>
                    <Button class="m-3" @click.prevent="clearAllButacas" v-if="!plazas">Limpiar todas</Button>
                </div>
                <div class="col-12">   
                    <div class="form-group">
                        <label>AFORO REGIÓN: {{ aforoTotal }}</label>
                    </div>
                    <div class="form-group">
                        <label>AFORO BLOQUEADO: {{ plazasBloqueadas }}</label>
                    </div>
                    <div class="form-group">
                        <label>AFORO A LA VENTA: {{ plazasLibres }}</label>
                    </div>
                </div>

                <div class="col-12">
                    <FormInput label="Concepto" v-model="concepto" />
                </div>
                <div class="col-12 my-3" v-if="!loading">
                    <EtiquetaComponent @seleccionada="(etiquetaSeleccionada) => etiqueta = etiquetaSeleccionada" />
                </div> 
                <div class="col-12">
                    <Button class="btn-lg btn-block" type="button" name="button" @click="bloquearAsientos" :disabled="bloquear_boton || bloqueando">Bloquear / Liberar</Button>
                    <div class="col-12 text-center" v-if="bloqueando" style="height: 150px">
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import LeyendaColorPlano from './LeyendaColorPlano.vue';
import { Popover } from 'bootstrap';
import EtiquetaComponent from '../../../events/sesiones/bloquear-asientos/EtiquetaComponent.vue';

export default {
    data() {
        return {
            svg_loaded : '',
            loading: true,
            svgpanzoom: null,
            svg: null,
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            ocupadaColor: 'red', 
            seleccionadaColor: '#8CA9D9',
            bloqueadaColor: '#BF95C4', 
            enSesionColor: 'yellow', 
            vendidaAbonosColor: 'red',
            bloqueadaAbonosColor: 'purple',
            enCarritoAbonosColor: 'orange', 
            vendidaEventosColor: 'black',
            bloqueadaEventosColor: 'purple', 
            enSesionEventosColor: 'orange',
            svgRendered: null,
            isPanning: false, 
            contadorPlazas: null,
            bloqueando: false,
            plazasSeleccionadas: [],
            seleccionarTodas: false,
            concepto: '',
            asientos: [],
            plazas: null,
        }            
    },
    created() {
        this.getButacas();
    },
    computed: {
        bloquear_boton() {
            return !(this.plazasSeleccionadas.length > 0);
        },
        plazasBloqueadas() {
            return this.plazas.filter(plaza => plaza.ocupada && plaza.ocupada.bloqueada).length;
        },
        plazasLibres() {
            return this.plazas.filter(plaza => plaza.libre).length;
        },
        aforoTotal() {
            return this.plazas.length;
        },
        recinto() {
            return this.$store.getters.getRecinto;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        getButacas() {
            this.loading = true;

            const params = {
                lista_id: this.$store.getters.getListaId,
                recinto_id: this.recinto.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.listado-butacas'), params).then(res => {
                this.plazas = res.data.data;
                this.getSvg();        
            }).finally(() => this.loading = false);
        },
        getSvg() {
            const params = {
                recinto_id: this.recinto.id
            };
            this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                .then(({ data: { svg } }) => {
                    this.renderLeafletSvg(svg);
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    console.warn('Error al recuperar el SVG del recinto anexo');
                });
        },
        renderLeafletSvg(svg) {
            const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;

            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');

            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                if (plaza) {
                    const title = this.getButacaName(plaza);

                    if (plaza.libre && !plaza.ocupada.bloqueada) {     
                        this.drawPopover(circle, plaza, title);      
                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s';
                        circle.setAttribute('fill', this.originalColor);

                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(plaza);
                                }
                            }, 150);
                        });                    
                    } else if (plaza.ocupada && plaza.ocupada.bloqueada) {
                        if (plaza.info_ocupada && plaza.info_ocupada.concepto) {
                            let content = `<div><strong>Concepto: </strong>${plaza.info_ocupada.concepto}</div>`
                            this.drawPopover(circle, plaza, title, content);      
                        }
                        this.drawPopover(circle, plaza, title);      
                        circle.setAttribute('fill', this.bloqueadaColor);
                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.bloqueadaColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(plaza);
                                }
                            }, 150);
                        }); 
                    } else if (plaza.ocupada && plaza.ocupada.sesion) {
                        circle.setAttribute('ocupada', 'true');
                        circle.style.cursor = 'not-allowed';
                        circle.setAttribute('fill', this.enSesionColor);
                        this.drawPopover(circle, plaza, title); 
                    } else if (plaza.ocupada && plaza.ocupada.venta) {
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.vendidaAbonosColor);
                        circle.style.cursor = 'not-allowed';
                        this.drawPopover(circle, plaza, title); 
                    } else if (plaza.ocupada && plaza.ocupada.evento_bloqueo) {
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.bloqueadaEventosColor);
                        circle.style.cursor = 'not-allowed';
                        this.drawPopover(circle, plaza, title); 
                    } else if (plaza.ocupada && plaza.ocupada.evento_venta) {
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.vendidaEventosColor);
                        circle.style.cursor = 'not-allowed';

                        let content

                        if (plaza.info_ocupada.numero_pedido) {
                            circle.style.cursor = 'pointer';
                            content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                            circle.addEventListener('click', () => {
                                let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                window.open(url, '_blank');
                            });
                        }
                        this.drawPopover(circle, plaza, title, content); 
                    } else if (plaza.ocupada && plaza.ocupada.evento_sesion) {
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.enSesionEventosColor);
                        circle.style.cursor = 'not-allowed';
                        this.drawPopover(circle, plaza, title); 
                    } 
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },

        drawPopover(circle, plaza, title = null, content = '') {

            if (plaza.ocupada) {
                if (plaza.ocupada.bloqueada) {
                    content += `<div><strong>Plaza bloqueada</strong></div>`;
                }
                if (plaza.ocupada.venta) {
                    content += `<div><strong>Vendida</strong></div>`;
                }
                if (plaza.ocupada.sesion) {
                    content += `<div><strong>En sesión</strong></div>`;
                }
                if (plaza.ocupada.evento_venta) {
                    content += `<div><strong>Vendida en evento</strong></div>`;
                }
                if (plaza.ocupada.evento_bloqueo) {
                    content += `<div><strong>Bloqueada en evento</strong></div>`;
                }
                if (plaza.ocupada.evento_sesion) {
                    content += `<div><strong>En sesión en evento</strong></div>`;
                }
            }

            if (plaza.libre) {
                content = `<div><strong>Plaza libre</strong></div>`;
            }

            const popoverOptions = {
                title: title,
                content: content,
                trigger: 'hover',
                html: true
            };

            new Popover(circle, popoverOptions);
        },
        bloquearAsientos() {
            this.bloqueando = true;

            const params = {
                filters: {},
                lista_id: this.$store.getters.getListaId,
                recinto_id: this.recinto.id,
                butacas: this.asientos,
            };
            if (this.concepto && this.concepto.length > 0) {
                params.concepto = this.concepto;
            }
            if(this.etiqueta){
                params.etiqueta_bloqueo_id = this.etiqueta.id
            }
            this.$store.dispatch(this.config.getVuexAlias('back.abonos.bloquear.butacas'), params).then(res => {
                this.concepto = '';
                this.bloqueando = false;
                this.asientos = [];

                this.svgRendered = null;
                this.getButacas();
                this.plazasSeleccionadas = [];
            });
        },
        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(butaca) {
            const nButaca = butaca.butaca;
            const nFila = butaca.fila;
            const sector = butaca.sector_name;
            const visibilidad_reducida = butaca.visibilidad_reducida;
            const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
            let name = '';

            if (sector) {
                name += `Sector: ${sector} - `;
            }

            if (!nButaca && !nFila) {
                name += `Plaza: ${butaca.numero}`;
            } else {
                name += `Fila: ${nFila} - Butaca: ${nButaca}`;
            }

            if (visibilidad_reducida) {
                name += '<span class="text-danger"> Visibilidad Reducida</span>';
            }

            if (porcentaje_visibilidad) {
                name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
            }

            return name;
        },
        clickButaca(plazaSeleccionada) {
            const plazaEncontrada = this.plazas.find(plaza => plaza.id === plazaSeleccionada.id);

            if (plazaEncontrada) {
                plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada; 

                if (plazaEncontrada.seleccionada) {
                    if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                        this.plazasSeleccionadas.push(plazaSeleccionada);
                        this.asientos.push(plazaSeleccionada.id);
                    }
                } else {
                    const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                    if (index !== -1) {
                        this.plazasSeleccionadas.splice(index, 1);
                        this.asientos.splice(index, 1);
                    }
                }
            }
        },
        selectAllButacas() {
            this.seleccionarTodas = true;
            var plazas_formatted = this.plazas.filter(plaza => plaza.libre == true || plaza.libre == false && plaza.ocupada.bloqueada == true);
            plazas_formatted.forEach(plaza => {
                this.clickButaca(plaza);
            });
        },
        clearAllButacas() {
            this.asientos = [];
            for(var fila in this.filas) {
                for(var asiento in this.filas[fila]) {
                    if(this.filas[fila][asiento].seleccionado) {
                        this.filas[fila][asiento].seleccionado = !this.filas[fila][asiento].seleccionado;
                    }
                }
            }              
        },
    },
    components: { LeafletComponent, LeyendaColorPlano, EtiquetaComponent }
}
</script>